
// modelled after Bootstrap alerts

export type AppMessageType = "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark";

export interface AppMsgLocales {
    close: string;
}

export class AppMessage {
    protected static $: JQueryStatic = (window as any).$;
    protected static locales: AppMsgLocales = {close: "Close"};

    public readonly text: string;
    public readonly type: AppMessageType;
    public readonly canDismiss: boolean;
    public readonly id: number;

    protected static counter = 0;

    constructor(text: string, type: AppMessageType, canDismiss: boolean = true) {
        this.text = text;
        this.type = type;
        this.canDismiss = canDismiss;
        this.id = ++AppMessage.counter;
    }

    public display(): void {
        AppMessage.$("#app-messages").append(this.toHtml());
        AppMessage.$('html, body').animate({scrollTop: 0}, 260);
    }

    public toHtml(): string {
        if (this.canDismiss === false) {
            return `<div class="alert alert-${this.type}" role="alert">${this.text}</div>`;
        }
        return `<div class="alert alert-${this.type} alert-dismissible fade show" role="alert">${this.text}
            <button type="button" class="close" data-dismiss="alert" aria-label="${AppMessage.locales.close}">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>`;
    }

    public static setJquery($: JQueryStatic): void {
        AppMessage.$ = $;
    }

    public static setLocales(locales: AppMsgLocales) {
        AppMessage.locales = locales;
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

}
